import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function FullLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <Loader2 className="h-8 w-8 animate-spin text-green-500" />
    </div>
  );
}

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

export function PublicOnlyRoute({ children }) {
  const { user } = useAuth();
  const [params] = useSearchParams();
  if (user === null) return <FullLoader />;
  if (user && user !== false) {
    const next = params.get("next");
    return <Navigate to={next || (user.role === "admin" ? "/admin" : "/")} replace />;
  }
  return children;
}
